import { useLanguage } from "@/i18n/LanguageContext";
import { useSEO } from "@/hooks/useSEO";
import { Reveal } from "@/components/motion/Reveal";

const ABOUT_IMG = "/about-collaboration.webp";

export default function AboutPage() {
  const { t } = useLanguage();
  useSEO({ title: t.about.seo.title, description: t.about.seo.description, path: "/about" });
  const a = t.about;

  return (
    <div data-testid="about-page" className="container-site py-14 sm:py-20 lg:py-28">
      <Reveal>
        <p className="eyebrow">{a.eyebrow}</p>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold tracking-tight">{a.title}</h1>
        <p className="mt-5 max-w-2xl text-base sm:text-lg text-muted-foreground leading-relaxed">{a.intro}</p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-7 space-y-12 lg:space-y-16">
          {a.chapters.map((ch, i) => (
            <Reveal key={ch.num} delay={i * 0.05}>
              <article className="relative pl-16 sm:pl-20">
                <span
                  className="absolute left-0 top-0 font-mono text-3xl sm:text-4xl font-semibold text-ochre/80"
                  aria-hidden="true"
                >
                  {ch.num}
                </span>
                <h2 className="font-display text-xl sm:text-2xl font-bold tracking-tight">{ch.title}</h2>
                <p className="mt-3 text-muted-foreground leading-relaxed">{ch.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.15}>
            <figure className="lg:sticky lg:top-28">
              <div className="overflow-hidden rounded-xl border border-border shadow-sm">
                <img src={ABOUT_IMG} alt={a.imageAlt} className="h-72 sm:h-96 w-full object-cover" loading="lazy" />
              </div>
              <div className="mt-6 rounded-xl border border-border bg-card p-6 sm:p-8">
                <h2 className="font-display text-lg font-bold">{a.identity.title}</h2>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
                  <strong className="text-foreground">Congo Bourse.</strong> {a.identity.cb}
                </p>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
                  <strong className="text-foreground">MouyIA.</strong> {a.identity.mouyia}
                </p>
              </div>
            </figure>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
